import ApiClient from 'core/api'
import authService from 'core/auth/auth-service'
import { remove } from 'core/indicator/pending-tasks-redux'
import { add } from 'core/spinner/redux/actions'
import { loadDeviceCustomFields } from 'modules/operational/device/advanced-search/redux/action'
import { envs } from './envHandler'
import { ApplicationState } from './redux'
import { INITIALIZE_CUSTOM_FIELDS, LOAD_DEVICE_CUSTOM_FIELDS, LOAD_OFFSET_VALUE } from './redux/applicationReducer'

function getOffset() {
  const promise = new Promise((resolve, reject) => {
    ApiClient
      .get(`${envs.REACT_APP_API_URL}/timezone-offset`)
      .then((response: any) => {
        resolve(response.data || 0)
      })
      .catch((error) => {
        reject(error)
      })
  })

  return promise
}

function getParametersByOpco(currentOpco: string | null) {
  const promise = new Promise((resolve, reject) => {
    ApiClient
      .get(
        `${envs.REACT_APP_API_URL}/parameters?type=device_custom_fields&name=${currentOpco}`
      )
      .then((response: any) => {
        resolve(response.data || [])
      })
      .catch((error) => {
        reject(error)
      })
  })

  return promise
}

export default function initializeParameters(callback?: any) {
  return async (dispatch: any, getState: () => ApplicationState) => {
    if (!getState().application.loadedOffset) {
      getOffset()
        .then((data) => {
          dispatch({ type: LOAD_OFFSET_VALUE, payload: { data: data, loaded: true } })
          remove(INITIALIZE_CUSTOM_FIELDS)

          if (callback) {
            dispatch(callback())
          }
        })
        .catch(() => {
          remove(INITIALIZE_CUSTOM_FIELDS)
        })
    }

    if (!getState().application.parameters.loaded) {
      add(INITIALIZE_CUSTOM_FIELDS, {})

      getParametersByOpco(authService.getCurrentOpco())
        .then((data) => {
          dispatch({ type: LOAD_DEVICE_CUSTOM_FIELDS, payload: data })
          remove(INITIALIZE_CUSTOM_FIELDS)

          if (callback) {
            callback()
          }
        })
        .catch(() => {
          remove(INITIALIZE_CUSTOM_FIELDS)
        })
    } else {
      dispatch(loadDeviceCustomFields())
      dispatch({ type: LOAD_DEVICE_CUSTOM_FIELDS, payload: getState().application.parameters.map })
    }
  }
}